export const PROGRAM_TYPE_BACKGROUND_ALPHA = 0.2;
